<template>
    <NuxtLayout>
        <NuxtPage />
        <UNotifications />
    </NuxtLayout>
</template>

<style>
html,
body {
    @apply bg-white text-hd-primary-original;
}
</style>
<script setup lang="ts"></script>
